
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
//icons
import { FaCrosshairs } from 'react-icons/fa';
//  api
import { getBookStores } from 'api/company';
//slices
import { userSelector } from 'slices/user';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Button from 'components/userzone/buttons/ButtonCustom';
import { CustomSelectComponent } from 'components/CustomSelectComponent';

const BenefitedBookStore = ({
  setFormInfo,
  handleChangeSave,
  errorSave,
  successSave,
  loading
}) => {
  const { benefitedBookstore } = useSelector(userSelector);
  const { t } = useTranslation(['register', 'backoffice']);
  const [benefitedBookstoreOptions, setBenefitedBookstoreOptions] = useState([]);
  const { assignedLibrary } = useAssignedLibrary();

  const handleBookstoreSelection = (storeId) => {
    setFormInfo({ benefited_bookstore: storeId });
  };

  function isEmptyObject(object) {
    return Object.values(object).every(value => value === "");
  }

  useEffect(() => {
    const fetchBookStores = async () => {
      try {
        const { status, data } = await getBookStores();
        if (status === 200) {
          const bookStores = data.results.map((store) => ({
            value: store?.id,
            label: store?.name,
            subtitle: store?.direccion,
          }));
          setBenefitedBookstoreOptions(bookStores);
        }
      } catch (error) {
        console.error('Error fetching book stores:', error);
      }
    };

    fetchBookStores();
  }, []);

  return (
    <Row className="section d-flex section-responsive">
      <Col md={8} >
        <CustomSelectComponent
          handleSelection={handleBookstoreSelection}
          options={benefitedBookstoreOptions}
          {...(!isEmptyObject(benefitedBookstore || {}) && { selectedOptionDefault: benefitedBookstore })}
        />
      </Col>
      <Col md={12} >
        <p className="locate-me mt-2">
          <Link to={`/${assignedLibrary}/librerias/mapa`}>
            <FaCrosshairs />
            <span id="loc">{t('currentlocation')}</span>{' '}
          </Link>
        </p>
      </Col>
      <Col md={12} id="bookshop-save" className="d-flex w-100 justify-content-end gap-2">
        {errorSave !== '' && (
          <div className="alert-danger align-items-center">
            <span className="m-0 text-danger">{errorSave}</span>
          </div>
        )}
        {successSave && (
          <div className="alert-success align-items-center">
            <span className="m-0 correct-message">{t('personalinformation')}</span>
          </div>
        )}
        <Button onClick={handleChangeSave} variant="primary" extraClass="m-2 width-btn-save" loading={loading}>
          {t('save', { ns: 'backoffice' }).toUpperCase()}
        </Button>
      </Col>
    </Row>
  );
};

export default BenefitedBookStore;